import { useTranslation } from 'react-i18next'
import { ChipTabs } from '../../design/ChipTabs'
import {
  competitionBoardTabs,
  type CompetitionBoard,
  type CompetitionDiscipline,
} from '@structural-climbing/validation'

interface Props {
  discipline: CompetitionDiscipline
  board: CompetitionBoard
  onChange: (board: CompetitionBoard) => void
}

const BOARD_LABEL: Record<CompetitionBoard, string> = {
  general: 'competitions.boardGeneral',
  boulder: 'routes.disciplineBouldering',
  lead: 'routes.disciplineLead',
}

/**
 * General / Bouldering / Lead, for a combined competition. General comes first
 * and adds the two disciplines together; each discipline keeps its own board
 * as well. Renders nothing for a single-discipline competition.
 */
export function BoardTabs({ discipline, board, onChange }: Props) {
  const { t } = useTranslation()
  const boards = competitionBoardTabs(discipline)
  if (boards.length < 2) return null

  return (
    <ChipTabs
      aria-label={t('routes.discipline')}
      value={board}
      onChange={onChange}
      options={boards.map((b) => ({ key: b, label: t(BOARD_LABEL[b]) }))}
    />
  )
}
